import { styled } from '@mui/material/styles';
import { AdditionalProps } from './types';

export const ContentBlockStyled = styled('div')<AdditionalProps>`
  margin-bottom: ${({ gutterBottom }) => (gutterBottom ? 'auto' : 0)};
  padding: 0;
  border-radius: 20px;
  background-color: unset;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: ${({ gutterBottom }) => (gutterBottom ? '56px' : 0)};
    padding: 48px 24px;
    background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;
